// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__Hrybx","container":"Home_container__1ukFy","brackets":"Home_brackets__27-kA","binaryglobe":"Home_binaryglobe__pgoWE","hello":"Home_hello__34DJr"};